import React from "react";
import { locales } from "../../locales";
import Article from "./Article";

const Newsticker = ({ langId, data, commune }) => {
  return (
    <div className="flex flex-col">
      <span className="text-left font-bold mt-20 text-32 leading-38 wort-medium:px-5">
        {locales[langId].articleTitle + " " + commune}
      </span>
      <div className="mt-5 wort-medium:grid gap-3 grid-cols-2 wort-medium:px-5">
        {data.map((item, index) => {
          return (
            <Article
              key={index}
              index={index}
              langId={langId}
              data={item}
              isCommuneArticle={true}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Newsticker;
